import { jsx as e, jsxs as x } from "react/jsx-runtime";
import { av as L, a8 as g } from "../../vendor-CPVnY93G.js";
import { useRef as P } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as y } from "../../utils/omitStyleRenderProps/index.js";
import { FieldDescription as C } from "../FieldDescription/index.js";
import { FieldError as N } from "../FieldError/index.js";
import { SelectFieldLabel as R } from "./SelectFieldLabel/index.js";
import { Surface as j } from "../Surface/index.js";
import { SelectFieldValueProvider as w } from "./SelectFieldContext/index.js";
import { SelectValue as A } from "./SelectValue/index.js";
import { SelectMenuContent as M } from "./SelectFieldContent/index.js";
import { SelectListBox as V } from "./SelectListBox/index.js";
import '../../assets/index52.css';const z = "_selectField_dho2r_1", B = "_popover_dho2r_41", D = "_surface_dho2r_48", r = {
  selectField: z,
  popover: B,
  surface: D
};
function X({
  label: l,
  errorMessage: s,
  description: d,
  items: t,
  onLoadMore: n,
  placeholder: f,
  search: a,
  "aria-label": m,
  isLoading: h = !1,
  hasMore: p = !0,
  isVirtualized: u = !1,
  fullWidth: v = !1,
  startIcon: S,
  horizontal: F = !1,
  ...o
}) {
  const c = P(null), i = (l ?? m ?? "options").toString().toLocaleLowerCase(), b = f ?? `Choose ${i}`, _ = a?.placeholder ?? `Search ${i}`, $ = Array.isArray(o.value) ? o.value.length > 0 : !!o.value;
  return /* @__PURE__ */ e(
    L,
    {
      ...y(o),
      "data-component": "SelectField",
      "data-selection-mode": o.selectionMode,
      "data-has-selection": $ || void 0,
      "data-fullwidth": v || void 0,
      "data-horizontal": F || void 0,
      className: r.selectField,
      children: /* @__PURE__ */ x(w, { items: t, children: [
        /* @__PURE__ */ e(R, { children: l }),
        /* @__PURE__ */ e(A, { ref: c, placeholder: b, startIcon: S }),
        /* @__PURE__ */ e(C, { children: d }),
        /* @__PURE__ */ e(N, { children: s }),
        /* @__PURE__ */ e(g, { className: r.popover, triggerRef: c, children: /* @__PURE__ */ e(j, { className: r.surface, children: /* @__PURE__ */ e(M, { search: a, searchPlaceholder: _, children: /* @__PURE__ */ e(
          V,
          {
            items: t,
            isLoading: h,
            onLoadMore: n,
            hasMore: p,
            isVirtualized: u
          }
        ) }) }) })
      ] })
    }
  );
}
export {
  X as SelectField
};
